import React from 'react';
import { ImageFile } from '~/data/types/images';

const ArrowLeftIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 16"
    >
      <path
        d="M5.79998 1.47656C4.54523 4.53539 2.88203 12.1266 3.39997 14.5266"
        stroke="#00D6D1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M11.2003 1.47656C9.60031 4.87656 7.59964 10.4766 7.59998 13.4766"
        stroke="#00D6D1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M1 5.60234C2.04348 4.84547 6.21739 3.32966 13 5.60211"
        stroke="#00D6D1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M1 11.6023C2.04348 10.8455 6.21739 9.32966 13 11.6021"
        stroke="#00D6D1"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </Component>
  );
};

export default ArrowLeftIcon;
